<template>
  <span class="renderer text-mono">
    <strong class="profiles" v-if="!!object.profilesCount">
      {{ object.profilesCount }}
    </strong>
    <span v-else class="text-secondary">0</span>
  </span>
</template>

<script>
  export default {
    name: 'ProfilesTableRenderer',
    props: ['object'],
  }
</script>

<style lang="scss" scoped>

</style>
